// extracted by mini-css-extract-plugin
module.exports = {"back":"securitySubPageBack_back__QHhHw","arrow":"securitySubPageBack_arrow__De71T","text":"securitySubPageBack_text__M2jOc"};